// extracted by mini-css-extract-plugin
module.exports = {"returnSelectionWrapper":"datepicker-style-module--returnSelectionWrapper--1ar4p"};